import { applyMiddleware, legacy_createStore as createStore, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'
import { createRootReducer } from './root-reducer'
import { rootSaga } from './root-saga'

export const history = createBrowserHistory()

const composeEnhancers =
  (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

export const configureStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware()

  const middlewares = [
    thunkMiddleware,
    sagaMiddleware,
  ]

  const enhancer = composeEnhancers(applyMiddleware(...middlewares))

  const reducers = createRootReducer()

  const store = createStore(reducers, initialState, enhancer)

  sagaMiddleware.run(rootSaga)

  return store
}
